import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';
import { StarbaseDataService } from 'starbase-launcher';

@Injectable({
  providedIn: 'root'
})
  /** DataService extension class used to call data from the Help Desk system
   * and to deal with caching needs for that data.
   */
export class HelpDeskService extends StarbaseDataService<any> {
  protected _staleDataTimeout: number;
  protected _getOneUri: string;
  protected _getAllUri: string;
  protected _postUri: string;
  protected _putUri: string;
  protected _deleteUri: string;
  protected _broadSearchUri: string;

  private getHelpByViewNameUrl = '/api/HelpDataModels/GetAllByViewName?viewName='; // GET many

  private getAllHelpUrl = '/api/HelpDataModels'; // GET all


  constructor(private httpX: HttpClient, private webAPIx: WebApiService) {
    super(httpX, webAPIx);
  }
  get getHelpByViewName() {
    return this.getHelpByViewNameUrl;
  }
  get getAllHelpFromServer() {
    return this.getAllHelpUrl;
  }

  // public getTestData(): Observable<HelpDataModel[]> {
  // eslint-disable-next-line max-len
  //   const h1: HelpDataModel = new HelpDataModel().deserialize({ uid: 1, viewName: 'screen one', context: 'c1', text: 'how to use screen 1', createdByUser: 'test', createdDateTime: new Date(), lastModifiedByUser: 'test', lastModifiedDateTime: new Date(), loadedFromServer: new Date() });
  // eslint-disable-next-line max-len
  //   const h2: HelpDataModel = new HelpDataModel().deserialize({ uid: 2, viewName: 'screen one', context: 'c2', text: 'how to use screen 2...', createdByUser: 'test', createdDateTime: new Date(), lastModifiedByUser: 'test', lastModifiedDateTime: new Date(), loadedFromServer: new Date() });
  //   return of(new Array<HelpDataModel>(h1, h2));
  // }

}
